<template>
    <div class="home">

        <div id="container" ></div>
        
    </div>
</template>
<script>

import $ from 'jquery';
export default {
    data() {
        return {
        
        };
    },
    methods: {
        init(){
            let _this = this;
            var params = {
                "selectLevel":"detail",
                "selectName":"北京,朝阳区",
                "xaxisDateRange":"1920-01:2018-12",
                "titleCodes":"qiye",
                "selectResult":"registNum",
                "numLevel":"total_quantity",
                "management_forms_id":"",
                "industry_id":"",
                "establishment_time":"",
                "registered_capital":""
            }


            api.imap_getMapData(params).then(res=>{
                console.log(res.data,'ressssss');
                let json2 = res.data.list;
                let line = res.data.polyline;

                let map = new AMap.Map("container", {
                    zoom: 14,
                    zooms:[12,20], //设置缩放级别范围 3-20 级
                    center:[json2[0].longitude, json2[0].latitude],
                    resizeEnable: true
                });

                _this.handlePolygon(map, "朝阳区");

                let json = [];
                json2.forEach(function(val,index){
                    json.push({
                        name: val.company_name,
                        lnglat: [val.longitude, val.latitude],
                        address: val.address,
                        entId:val.entId,
                        style:1
                    })
                })

                setTimeout(()=>{
                        
                    // 创建样式对象
                    var style = [{
                        url: 'http://a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
                        anchor: new AMap.Pixel(6, 6),
                        size: new AMap.Size(17, 39)
                    }, {
                        url: 'http://a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
                        anchor: new AMap.Pixel(4, 4),
                        size: new AMap.Size(17, 19)
                    }, {
                        url: 'http://a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
                        anchor: new AMap.Pixel(3, 3),
                        size: new AMap.Size(17, 19)
                    }];

                    var mass = new AMap.MassMarks(json, {
                        opacity: 0.8,
                        zIndex: 111,
                        cursor: 'pointer',
                        style: style
                    });

                    var marker = new AMap.Marker({content: ' ', map: map});

                    var infoWindow = new AMap.InfoWindow({offset: new AMap.Pixel(10, -10)});

                    mass.on('click', function (e) {
                        // 准备标注信息
                        let content = "<table id='" + e.data.entId + "' cellpadding='0' cellspacing='0' style='width: 280px;'>" +
                                    "<tr>" +
                                        "<td style='width: 50px;'>企业名称：</td>" +
                                        "<td style='width: 70px;'>"+e.data.name+"</td>" +
                                    "</tr>" +
                                    "<tr>" +
                                        "<td>企业地址：</td>" +
                                        "<td colspan='3'>"+e.data.address+"</td>" +
                                    "</tr>" +
                                "</table>";

                        // marker.setPosition(e.data.lnglat);
                        // marker.setLabel({content: content});

                        infoWindow.setContent(content);
                        infoWindow.open(map, e.data.lnglat);
                    });

                    mass.setMap(map);
                    
                },1000)
            })
            
        },
        handlePolygon(map, curDistrict) {
            
            let district = null;
            let polygons=[];
            
            //加载行政区划插件
            if(!district){
                //实例化DistrictSearch
                var opts = {
                    subdistrict: 0,   //获取边界不需要返回下级行政区
                    extensions: 'all',  //返回行政区边界坐标组等具体信息
                    level: 'district'  //查询行政级别为 市
                };
                district = new AMap.DistrictSearch(opts);
            }
            //行政区查询
            district.setLevel(curDistrict)
            district.search(curDistrict, function(status, result) {
                map.remove(polygons)//清除上次结果
                polygons = [];
                var bounds = result.districtList[0].boundaries;
                if (bounds) {
                    for (var i = 0, l = bounds.length; i < l; i++) {
                        //生成行政区划polygon
                        var polygon = new AMap.Polygon({
                            strokeWeight: 1,
                            path: bounds[i],
                            fillOpacity: 0.4,
                            fillColor: '#80d8ff',
                            strokeColor: '#0091ea'
                        });
                        polygons.push(polygon);
                    }
                }

                map.add(polygons)
                map.setFitView(polygons);//视口自适应
            });
            
        }
        
    },
    mounted() {
        this.init();
    },
  
};
</script>
<style scoped lang="less">
.home {
  width: 100vw;
  height: 100vh;
}

#container{
    height:100%;
}
 

</style>


// WEBPACK FOOTER //
// src/view/login/map2.vue